import { withTranslation } from "react-i18next";
import { Form, Button, Input, notification } from "antd";
import { connect } from "react-redux";

import Text from "components/Text";
import * as Styled from './styled';
import { patch } from "library/endpoints";
import { fetchUserSuccess } from "modules/auth/actions";

/**
 * EmailForm
 * @param {*} props 
 * @returns 
 */
const EmailForm = (props) => {
  const onFinish =  async (values) => {
    try {
      const { data } = await patch(`/frontend/user/email`, values);
      props.fetchUserSuccess(data);
      notification.success({
        message: 'Modification effectuée !',
        description:
          'Vos informations ont été mises à jour',
      });
      props.setCurrentView('default')

    } catch (error) {
      console.log(error)
      notification.error({
        message: 'Une erreur s est produite',
        description:
          'Vérifiez vos informations avant d essayer à nouveau',
      });
    }
  };
  
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
      <Styled.OptionsSelector
        onClick={() => props.setView('basket')}      
      >
        <Text style={{ marginBottom: 20, marginTop: -4 }} size={20} color="#53b6ba">Modifier mon adresse E-Mail</Text>
      </Styled.OptionsSelector>
      
      <div style={{ width: '100%', margin: 'auto', marginTop: 20 }}>
        <Form
          name="basic"
          labelCol={{
            span: 12,
          }}
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Votre adresse E-Mail"
            name="email"
            rules={[
              {
                required: true,
                message: props.t('FrontClient.Basket.Delivery.InputMandatoryError', 'Ce champ est obligatoire'),
                type: 'email'
              },
            ]}
            initialValue={props.auth.user.email}
          >
            <Input />
          </Form.Item>

          

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%', marginBottom: 20  }}>
              Enregistrer
            </Button>
            <Text align="center" onClick={() => props.setCurrentView('default')}>Annuler</Text>
          </Form.Item>
        </Form>
      </div>
      
    </>
  )
}

const stateToProps = state => ({
  auth: state.auth
})

const dispatchToProps = {
  fetchUserSuccess
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(EmailForm));